import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AsyncSelect from "react-select/async";
import { Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { customStylesSelect } from 'common/data/settings';
//store
import { CreateUserForProject, getUserbasedonProjects } from 'store/manageclient/action';
//helpers
import { getAuthorizationToken } from 'helpers/storagehelper';
import { dateStringAt9AM, formatDateString, getTimeSplit, onClosePicker } from 'helpers/util';

const ProjectUserForm = (props) => {
  const { selectedProject, activeUser, isEdit, show, toggle } = props;
  const [selectedUser, setSelectedUser] = useState(null);
  const [customLoginTime, setCustomLoginTime] = useState(null);
  const [previousDateTime, setPreviousDateTime] = useState(null);
  const [isSecondary, setIsSecondary] = useState(false);
  const datetimeInputRef = useRef(null);
  const allUsers = useSelector((state) => state?.userlist?.userlist)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isEdit && activeUser?.customLoginTime) setCustomLoginTime(activeUser?.customLoginTime);
    else setCustomLoginTime(dateStringAt9AM);
    setIsSecondary(isEdit ? !!activeUser?.issecondary : false);
  }, [activeUser, show])

  const getUserListData = async (searchValue, callback) => {
    try {
      const data = await fetch(`${process.env.REACT_APP_API_URL}/Users/GetUsers`, {
        method: 'post',
        headers: {
          Authorization: `Bearer ${getAuthorizationToken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          searchKey: "useremail", searchValue, "pageNumber": 0,
          "pageSize": 20
        })
      }).then(res => res.json()).then(res => {
        console.log(res, "result")
        return res.data.map(el => ({ ...el, label: el.username, value: el.id }))
      })
      callback(data);
      return data
    }
    catch (err) {
      console.log(err, 'err')
      return []
    }
  };

  const loadOptions = (
    inputValue,
    callback
  ) => {
    getUserListData(inputValue, callback)
  };

  const handleDateTimeChange = (event) => {
    const newValue = event.target.value;
    const newTime = getTimeSplit(newValue);
    if (previousDateTime) {
      onClosePicker(newTime, previousDateTime, datetimeInputRef)
    }
    setCustomLoginTime(newValue);
    setPreviousDateTime(newValue);
  };

  const handleResponse = (status) => {
    if (status === 'SUCCESS') {
      toggle()
      dispatch(getUserbasedonProjects(selectedProject?.id))
    }
  };

  const HandleSaveClick = () => {
    if (!isEdit) {
      const promise = [];
      selectedUser.map(el => {
        const addUser = {
          userId: el?.value || el?.id,
          categoryId: selectedProject?.categoryid,
          subcategoryId: selectedProject?.id,
          customLoginTime: formatDateString(customLoginTime),
          issecondary: isSecondary
        }
        promise.push(dispatch(CreateUserForProject(addUser, handleResponse)))
      })
    }
    else {
      const editReq = {
        userId: activeUser?.userId,
        categoryId: selectedProject?.categoryid,
        subcategoryId: selectedProject?.id,
        customLoginTime: formatDateString(customLoginTime),
        issecondary: isSecondary
      }
      dispatch(CreateUserForProject(editReq, handleResponse))
    }
  };

  return <>
    <Modal isOpen={show} toggle={toggle}>
      <ModalHeader toggle={toggle} tag="h5">
        {isEdit ? `Edit ${activeUser?.firstName}` : `Add Users to  ${selectedProject?.name}`}
      </ModalHeader>
      <ModalBody>
        {
          !isEdit && <div className="mb-3">
            <AsyncSelect
              isMulti
              onChange={value => setSelectedUser(value)}
              cacheOptions
              loadOptions={loadOptions}
              defaultOptions={(allUsers?.data || [])?.map(el => ({
                ...el,
                label: el.username,
                value: el.id,
              }))}
              classNamePrefix="select2-selection"
              className="add_Zindex_one "
              styles={customStylesSelect}
            />
          </div>
        }
        {
          isEdit && <div><div className="mb-3">
            <Label for="firstName" className="form-label">
              First Name
            </Label>
            <Input
              name="firstName"
              id="firstName"
              className="form-control"
              type="text"
              value={activeUser?.firstName}
              disabled
            />
          </div>
            <div className="mb-3">
              <Label for="lastName" className="form-label">
                Last Name
              </Label>
              <Input
                name="lastName"
                id="lastName"
                className="form-control"
                type="text"
                value={activeUser?.lastName}

                disabled
              />
            </div>
            <div className="mb-3">
              <Label for="userEmail" className="form-label">
                Email
              </Label>
              <Input
                name="userEmail"
                id="userEmail"
                className="form-control"
                type="text"
                value={activeUser?.userEmail}
                disabled
              />
            </div>
          </div>
        }
        <div className="col-md-12">
          <Label for="customLoginTime" className="form-label">
            Custom Login time
          </Label>
          <input
            placeholder='Please select time'
            className="form-control"
            type="datetime-local"
            value={customLoginTime}
            onChange={handleDateTimeChange}
            id='customLoginTime'
            ref={datetimeInputRef}
          />
        </div>
        <div className="col-md-12 mt-3">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="isSecondary"
              checked={isSecondary}
              onChange={e => setIsSecondary(e.target.checked)}
            />
            <Label className="form-check-label" for="isSecondary">
              Mark as secondary account
            </Label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <div className="text-end">
          <button type="submit" className="btn btn-primary save-customer me-2" onClick={HandleSaveClick}>
            {isEdit ? `Update` : `Add`}
          </button>
          <button
            type="button"
            color="primary"
            className="btn btn-secondary"
            onClick={toggle}
          >
            Cancel
          </button>
        </div>
      </ModalFooter>
    </Modal>
  </>
}

export default ProjectUserForm;